import {IntegrationMessage} from "platform/integration/message/IntegrationMessage";
import {IntegrationClassId} from "platform/integration/message/IntegrationClassId";

export class IntegrationSymbolsReload implements IntegrationMessage {

    public classId: number = IntegrationClassId.CHART_SYMBOLS_RELOAD;
}
